import { OverrideStatus, Status } from 'src/app/enum/enum';

export class ColorScheduleGenerate {
  companyID: number = 0;
  daysInCycle: number = 7;
  scheduleStartDate: string = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  scheduleEndDate: string = new Date().toISOString().split('T')[0];
}

export class ProductionCycleSchedule {
  id: number = 0;
  companyId: number = 0;
  productionCycleId: number = 0;
  startDate: Date = new Date();
  endDate: Date = new Date();
  weekNumber: number = 0;
  color: string = '';
  displayName: string = '';
  isSelected?: boolean = false;
}

export class ProductionCycle {
  id: number = 0;
  companyId: number = 0;
  color: string = '';
  displayName: string = '';
  sortOrder: number = 0;
  status: OverrideStatus = OverrideStatus.Active;
  createdAt: Date = new Date();
  isSelected?: boolean = false;
}

export class ProductionCycleScheduleDate {
  id: number = 0;
  productionCycleScheduleId: number = 0;
  weekNumber: number = 0;
  color: string = '';
  displayName: string = '';
}

export class ColorSchedule {
  productionCycleId: number = 0;
  productionCycleScheduleId: number = 0;
  weekNumber: number = 0;
  color: string = '';
  displayName: string = '';
}